import { DISPLAY_TORCH_BUTTON } from "./torchButtonReducer"

export const displayTorchButton = (value) => ({
    type: DISPLAY_TORCH_BUTTON,
    payload: value
})